<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <v-card-title class="titulopagina">STOCK DE HARINA EN BODEGAS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="green darken-1" class="float-right ml-4" small dark @click="download" v-bind:disabled="!can_download">Excel</v-btn>
                        <v-btn color="blue darken-1" class="float-right" small dark @click="cargarStockBodega()"><v-icon>loop</v-icon></v-btn>
                        <v-select
                            :items="bodegas"
                            item-text="nombre"
                            item-value="id"
                            v-model="bodega"
                            label="Seleccione Bodega"
                            dense
                            @change="cargarStockBodega"
                        ></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
            </v-card-text>
        </v-card>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                    {{`TOTAL KILOS: ${total_kg}`}}
                    <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table
                    :headers="columnas"
                    :items="lista"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <loader-compartido></loader-compartido>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import Loader_Compartido from '@/components/shared/Loader_Compartido.vue';
export default {
    data:()=>({
        columnas: [
            {
                text: 'Lote',
                align: 'center',
                sortable: false,
                value: 'lote',
                class:'cabecera',
            },
            { text: 'Fecha Lote',
                align: 'center',
                sortable: false, 
                value: 'fecha',
                class:'cabecera',
            },
            { text: 'Cantidad Maxisacos Disponibles',
                align: 'center',
                sortable: false, 
                value: 'nmaxis',
                class:'cabecera',
            },
            { text: 'Maxisacos N°',
                align: 'left',
                sortable: false, 
                value: 'maxis',
                class:'cabecera',
            },
            { text: 'Kilos Disponibles',
                align: 'center',
                sortable: false,
                value: 'kilos',
                class:'cabecera',
            },
        ],
        lista:[],
        total_kg:0,
        url_excel: '',
        can_download: false,
        bodegas: [],
        bodega: 0
    }),
    mounted() {
        this.cargarBodegas();
        this.cargarStockBodega();
    },
    methods:{
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Reporte de Stock de Harina en Bodegas`, tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla muestra el stock de harina de la bodega que se seleccione.`},
                        {   tipo:`label`,   texto:`- Al seleccionar una Bodega, se carga el stock de esa bodega, esta información se puede exportar a excel`},
                        {   tipo:`label`,   texto:`- La Bodega "Reproceso en Planta", mostrará todos los maxisacos que se han enviado a reproceso. `},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarBodegas(){
            let url = `${this.base_url}bodegas`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data.filter(b => ((b.tipo_bodega == 'bodega' && !b.depende_de) || (b.tipo_bodega == 'reproceso') ) );
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarStockBodega(){
            this.mostrarLoading({titulo:'Cargando Stock Bodega...',color:'green'})

            let url = `${this.base_url}stock_bodega/${this.bodega}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.lista = res.data.data;
                this.total_kg = res.data.kilos;
                this.url_excel = res.data.url_excel;
                if(this.lista.length > 0){
                    this.can_download = true;
                }
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },
        download(){
            window.location.href = this.download_url.replace('bitacoras', 'movimientos') + this.url_excel;
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers', 'download_url'])
    },
    components:{
        'loader-compartido':Loader_Compartido,
        DatePicker,
        'modal-ayuda':ModalAyudas
    }
}
</script>